<template>
  <div id="modal-info-body">
    <h2 style="text-align: center">Gerenciar usuários</h2>
    <p>
      Os usuários do sistema são: Médicos, e Enfermeiros, Técnicos e Auxiliares
      de Enfermagem Odontólogos, Agentes Comunitários de Saúde, Coordenadores ou
      Gerentes, Administrador municipal do e-SUS e Secretários de Saúde.
    </p>
    <br />
    <p>
      O fluxo para um novo usuário ter acesso ao sistema e realizar seu
      Monitoramento e Avaliação na APS (M & A na APS) é o seguinte:
    </p>
    <ul style="list-style: decimal">
      <li>
        O profissional de saúde vai em LOGIN >>
        <a href="https://site.esusfeedback.com.br/criar-conta" target="_blank"
          >Criar conta</a
        >, preenche o formulário e comunica a gestão municipal;
      </li>
      <li>
        A representação da gestão municipal (Administrador(a) municipal do e-SUS
        PEC ou Centralizador, Coordenador(a) ou Secretário(a)) vai em
        <strong>INÍCIO >> Administração >> Gerenciar usuários</strong>, busca o
        usuário que ainda está inativo e ativa o acesso;
      </li>
      <li>
        O usuário entra com CPF e SENHA e consegue visualizar as informações dos
        cidadãos de acordo com sua lotação na APS municipal.
      </li>
    </ul>
    <p>
      Em suma, o profissional interessado em usar o sistema aqui deve clicar em
      <a href="https://site.esusfeedback.com.br/criar-conta" target="_blank"
        >Criar conta</a
      >
      na tela de LOGIN, preencher o formulário e clicar no botão
      <strong>CADASTRAR</strong>. Depois da conta criada, pedir a gestão
      municipal para ativar a conta em
      <strong>INÍCIO >> Administração >> Gerenciar usuários</strong>.
    </p>
    <br />
    <p>
      Como estamos adequados a Lei Geral de Proteção de Dados (PGPD), para o
      acesso ao sistema precisa-se que o usuário preencha o formulário aceitando
      os termos de uso e o gestor municipal ou representação, forneça
      autorização ou confirmação de que aquele determinado profissional de saúde
      tem autorização para acessar as informações e realizar o Monitoramento e
      Avaliação na APS.
    </p>
    <br />
    <p>
      Exceto os perfis de Secretário(a), Coordenador(a) e Administrador
      municipal do e-SUS, para acessar os dados dos demais perfis, o
      profissional de saúde precisar ter cadastro e lotação ativa no e-SUS PEC
      ou Centralizador municipal.
    </p>
    <br />
    <p>
      Se o profissional desejar mudar o perfil cadastrado no sistema, ele deve
      realizar uma solicitação formal ao suporte.
    </p>
    <h3>FUNCIONALIDADES</h3>
    <p>
      A qualquer momento o gestor municipal pode sentir a necessidade de
      <strong
        >dar ou negar o acesso ao sistema de Monitoramento e Avaliação na
        APS</strong
      >
      para algum usuário em específico, seja porque não faz mais parte do corpo
      de funcionários do município, seja por que fez uso indevido da informação.
      Para facilitar estas ações, você pode interpretar as informações e função
      desta tela assim:
    </p>
    <ul>
      <li>
        <strong>NOME DE USUÁRIO</strong> – informar o nome do usuário ou
        profissional de saúde cadastrado para encontrá-lo entre os usuários
        cadastrados;
      </li>
      <li>
        <strong>NOME</strong> – mostra o nome do profissional de saúde
        cadastrado;
      </li>
      <li>
        <strong>FUNÇÃO</strong> – mostra a função ou perfil que o usuário tem no
        sistema de Monitoramento e Avaliação na APS;
      </li>
      <li>
        <strong>STATUS</strong> – indica se o usuário
        <strong
          >tem acesso ao sistema (Ativo) ou não tem acesso ao sistema
          (Inativo)</strong
        >. Para ativar ou inativar um determinado usuário, basta escolher a
        opção desejada e clicar em salvar.
      </li>
      <li>
        <strong>NOVA SENHA</strong> – quando o usuário precisa de uma nova
        senha, o Administrador(a) municipal, Coordenador(a) ou Secretário(a)
        pode acessar este campo, digitar uma nova senha e confirmar clicando em
        salvar. Lembrar de informar a nova senha para o profissional de saúde.
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'DocGerenciarUsuario',
}
</script>
<style scoped>
#modal-info {
  flex: 0 1 33%;
}

#modal-info button {
  width: 35px;
  height: 35px;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  float: right;
}

#modal-info-body h2 {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
#modal-info-body .notas-tecnicas {
  text-align: start;
  border-bottom: 1px solid #c1c1c1;
}
#modal-info-body h3 {
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0;
}

#modal-info-body p {
  font-size: 14px;
  text-align: justify;
  margin-bottom: 0;
}

#modal-info-body ul {
  margin: 10px 25px 10px 25px;
  list-style-type: disc;
}

#modal-info-body ul li {
  font-size: 14px;
}

.modal-info-accessibility ul {
  display: inline-flex;
  margin: 10px 0 !important;
  padding: 0;
  gap: 5px;
}

.modal-info-accessibility ul li {
  border: 1px solid;
  list-style-type: none;
  padding: 5px;
  width: 30px;
  text-align: center;
  background-color: #6c757d;
  border-color: #6c757d;
  border-radius: 3px;
}

.modal-info-accessibility ul li a {
  color: #fff;
  font-size: 14px;
}

.modal-info-accessibility ul li a:hover {
  color: #000;
}
</style>
